var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_601_39533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 22.9344C44 31.8731 37.7846 39.3651 29.4258 41.3525C28.0057 41.6901 25.6909 43.2459 24.6545 46C23.6182 43.2459 21.9943 41.6901 20.5742 41.3525C12.2154 39.3651 6 31.8731 6 22.9344C6 12.4772 14.5066 4 25 4C35.4934 4 44 12.4772 44 22.9344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#09253C",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3337 22.3333H19.667V29.6667H30.3337V22.3333Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.667 22.3333V19.6667C21.667 17.8257 23.1594 16.3333 25.0003 16.3333C26.8413 16.3333 28.3337 17.8257 28.3337 19.6667",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_601_39533",
    x: 0,
    y: 0,
    width: 50,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_601_39533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_601_39533",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinUnlocked);
export default __webpack_public_path__ + "static/media/map-pin-unlocked.a450cd4f78899cc80040b3a2c1f9b238.svg";
export { ForwardRef as ReactComponent };